import { useEffect, useRef, useState } from 'react';
import { loadModules } from 'esri-loader';

const ElevationProfileWidget = ({ view }) => {
  const containerRef = useRef(null);
  const buttonRef = useRef(null);
  const graphicsLayerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!view || !view.ui || !view.map) return;

    let elevationProfile = null;
    let sketch = null;

    const setupWidget = async () => {
      await view.when();

      const [ElevationProfile, Sketch, GraphicsLayer] = await loadModules([
        'esri/widgets/ElevationProfile',
        'esri/widgets/Sketch',
        'esri/layers/GraphicsLayer'
      ]);

      const graphicsLayer = new GraphicsLayer({ title: 'Elevation Profile', visible: false });
      graphicsLayerRef.current = graphicsLayer;
      view.map.add(graphicsLayer);

      sketch = new Sketch({
        layer: graphicsLayer,
        view,
        creationMode: 'update',
        availableCreateTools: ['polyline'],
        visibleElements: {
          createTools: {
            point: false,
            polygon: false,
            rectangle: false,
            circle: false
          }
        }
      });

      elevationProfile = new ElevationProfile({
        view,
        profiles: [{ type: 'ground' }, { type: 'view' }],
        input: sketch,
        container: containerRef.current
      });

      const button = document.createElement('div');
      button.className = 'esri-widget esri-widget--button esri-icon-polyline';
      button.title = 'Elevation Profile';
      button.style.cursor = 'pointer';
      button.style.padding = '12px';
      button.onclick = () => setVisible(v => !v);

      buttonRef.current = button;
      view.ui.add(button, { position: 'top-left', index: 7 });

      // Inject close button into the widget header
      const injectCloseButton = () => {
        const header = containerRef.current?.querySelector('.esri-elevation-profile__header');
        if (header && !header.querySelector('.custom-close-button')) {
          const closeBtn = document.createElement('calcite-button');
          closeBtn.setAttribute('title', 'Close');
          closeBtn.setAttribute('appearance', 'transparent');
          closeBtn.setAttribute('scale', 'l');
          closeBtn.setAttribute('icon-start', 'x');
          closeBtn.setAttribute('color', 'grey'); // makes it grey
          closeBtn.className = 'custom-close-button';
          closeBtn.onclick = () => setVisible(false);

          header.appendChild(closeBtn);
        } else {
          setTimeout(injectCloseButton, 100);
        }
      };

      injectCloseButton();
    };

    setupWidget();

    return () => {
      if (elevationProfile) elevationProfile.destroy();
      if (sketch) sketch.destroy();
      if (graphicsLayerRef.current && view?.map) {
        view.map.remove(graphicsLayerRef.current);
      }
      if (buttonRef.current && view?.ui) {
        view.ui.remove(buttonRef.current);
      }
    };
  }, [view]);

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.style.backgroundColor = visible ? '#ffffff92' : '#fff';
    }
    if (graphicsLayerRef.current) {
      graphicsLayerRef.current.visible = visible;
    }
  }, [visible]);

  return (
    <div
      ref={containerRef}
      style={{
        display: visible ? 'block' : 'none',
        resize: 'both',
        overflow: 'auto',
        minWidth: '600px',
        minHeight: '300px',
        maxHeight: '400px',
        border: '1px solid #ccc',
        backgroundColor: '#fff',
        position: 'absolute',
        bottom: '20px',
        left: '60px',
        zIndex: 10
      }}
    />
  );
};

export default ElevationProfileWidget;
